<template>
  <div class="homepage">
    <!-- 导航栏 -->
    <nav class="navbar">
      <div class="container">
        <div class="brand">驴充充</div>

        <!-- 桌面菜单 -->
        <ul class="desktop-menu" v-if="!isMobile">
          <router-link
            to="/orderList"
            @click="showMobileMenu=false"
            :class="{ active: $route.name === 'orderList' }"
          >
            订单中心
          </router-link>
        </ul>

        <!-- 移动端菜单按钮 -->
        <button
          class="mobile-menu-btn"
          v-if="isMobile"
          @click="showMobileMenu=!showMobileMenu"
        >☰</button>

        <!-- 移动端展开菜单 -->
        <ul class="mobile-menu" v-show="showMobileMenu">
          <li><a href="#" @click="showLoginModal=true;showMobileMenu=false">订单中心</a></li>
        </ul>
      </div>
    </nav>

    <!-- 新增产品内容区域 -->
    <main class="product-main">
      <div class="container">
        <!-- 分类对应产品列表 -->
        <div class="category-products">
          <h3>{{ currentCategory }} 产品</h3>
          <div class="product-grid">
            <div
              v-for="product in filteredProducts"
              :key="product.id"
              class="product-card"
            >
              <img :src="product.image" alt="product.name" class="product-image">
              <h4>{{ product.name }}</h4>
              <p class="price">预计¥{{ product.price }}起</p>
              <p class="desc">{{ product.desc }}</p>
            </div>
          </div>
        </div>
      </div>
    </main>
    <br/>
    <!-- 页脚 -->
    <footer class="footer">
      <div class="container">
        <p>© 2025 广东广福宏宇保险经纪有限公司 粤ICP备2025485413号-1 服务及投诉电话：400-867-5672</p>
        <div class="footer-links">
          <a href="#about">关于我们</a>
          <a href="#contact">联系我们</a>
          <a href="#">隐私政策</a>
        </div>
      </div>
    </footer>

    <!-- 返回顶部按钮 -->
    <button
      class="back-to-top"
      v-show="showBackToTop"
      @click="scrollToTop"
    >↑</button>
  </div>
</template>

<script>

export default {
  name: 'product',
  data () {
    return {
      isMobile: false, // 移动端判断
      showMobileMenu: false, // 移动端菜单显示状态
      showLoginModal: false, // 登录模态框显示状态
      showBackToTop: false, // 返回顶部按钮显示状态
      currentCategory: '全部', // 当前选中分类
      // 新增产品模拟数据
      productList: [
        {
          id: 1,
          name: '四轮车公众责任险',
          category: '场地险',
          price: '60/枪/年',
          desc: '本保单扩展承保停车场责任',
          image: 'https://images.unsplash.com/photo-1542744173-8e7e53415bb0?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1974&q=80'
        },
        {
          id: 2,
          name: '四轮车财产险',
          category: '财产险',
          price: 0,
          desc: '针对保险标的包含储能资产的场站',
          image: 'https://images.unsplash.com/photo-1542744173-8e7e53415bb0?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1974&q=80'
        },
        {
          id: 3,
          name: '二轮车公众责任险',
          category: '责任险',
          price: '2.5/枪/年',
          desc: '本保险仅承担使用充电服务期间的责任',
          image: 'https://images.unsplash.com/photo-1579621970563-ebec7560ff3e?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1974&q=80'
        }
      ]
    }
  },
  computed: {
    // 从产品数据中提取分类（假设产品有category字段）
    categories () {
      const cats = ['全部']
      this.productList.forEach(p => {
        if (!cats.includes(p.category)) cats.push(p.category)
      })
      return cats
    },
    // 过滤当前分类的产品
    filteredProducts () {
      return this.currentCategory === '全部'
        ? this.productList
        : this.productList.filter(p => p.category === this.currentCategory)
    },
    // 判断是否为产品页（导航栏选中状态）
    isProductPage () {
      return true // 实际项目中可通过$route.path判断
    }
  },
  mounted () {
    // 初始化移动端判断
    this.isMobile = window.innerWidth <= 768
    window.addEventListener('resize', this.handleResize)
    window.addEventListener('scroll', this.handleScroll)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.handleResize)
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    // 窗口大小变化处理
    handleResize () {
      this.isMobile = window.innerWidth <= 768
      if (!this.isMobile) this.showMobileMenu = false
    },
    // 滚动事件处理
    handleScroll () {
      this.showBackToTop = window.scrollY > 300
    },
    // 返回顶部
    scrollToTop () {
      window.scrollTo({ top: 0, behavior: 'smooth' })
    }
  }
}
</script>
<style scoped>
/* 新增/修改样式 */
.homepage {
  display: flex;          /* 启用Flex布局 */
  flex-direction: column; /* 垂直排列子元素 */
  min-height: 100vh;      /* 至少占满整个视口高度 */
}

.product-main {
  flex: 1;                /* 内容区域自动扩展占据剩余空间 */
}
/* 页脚 */
.footer {
  background: #2c3e50;
  color: #fff;
  padding: 40px 0;
  text-align: center;
  margin-top: auto;       /* 页脚自动靠底部 */
}

.footer-links {
  margin-top: 20px;
  display: flex;
  gap: 20px;
  justify-content: center;
}

.footer-links a {
  color: #fff;
  text-decoration: none;
}

/* 返回顶部按钮 */
.back-to-top {
  position: fixed;
  bottom: 30px;
  right: 30px;
  background: #3498db;
  color: #fff;
  border: none;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  cursor: pointer;
  opacity: 0.8;
  transition: opacity 0.3s;
}

.back-to-top:hover {
  opacity: 1;
}
/* 基础样式 */
* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

body {
  font-family: 'Microsoft YaHei', sans-serif;
  line-height: 1.6;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}
/* 移动端适配 */
@media (max-width: 768px) {
  .desktop-menu {
    display: none;
  }

  .hero {
    height: 60vh;
    margin-top: 60px;
  }

  .section {
    padding: 50px 0;
  }
}
/* 新增样式 */
/* 导航栏选中状态 */
.desktop-menu .active a,
.mobile-menu .active a {
  color: #3498db;
  font-weight: bold;
  position: relative;
}

.desktop-menu .active a::after {
  content: '';
  position: absolute;
  bottom: -5px;
  left: 0;
  width: 100%;
  height: 2px;
  background: #3498db;
}

/* 产品分类列表 */
.product-categories {
  margin: 120px 0 40px;
}

.category-list {
  display: flex;
  gap: 15px;
  flex-wrap: wrap;
  margin-top: 20px;
}

.category-list button {
  padding: 8px 20px;
  border: 1px solid #ddd;
  border-radius: 20px;
  background: #fff;
  cursor: pointer;
  transition: all 0.3s;
}

.category-list button:hover,
.category-list button.active {
  background: #3498db;
  color: white;
  border-color: #3498db;
}

/* 产品列表 */
.product-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 30px;
  margin-top: 30px;
}

.product-card {
  background: #f8f9fa;
  padding: 25px;
  border-radius: 8px;
  transition: transform 0.3s;
}

.product-card:hover {
  transform: translateY(-5px);
}

.product-image {
  width: 100%;
  height: 180px;
  object-fit: cover;
  border-radius: 4px;
  margin-bottom: 15px;
}

.price {
  color: #e74c3c;
  font-size: 1.2rem;
  margin: 10px 0;
}
/* 导航栏 */
.navbar {
  position: fixed;
  top: 0;
  width: 100%;
  background: #fff;
  box-shadow: 0 2px 10px rgba(0,0,0,0.1);
  z-index: 1000;
  padding: 15px 0;
}

.navbar .container {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.brand {
  font-size: 1.2rem;
  font-weight: bold;
  color: #2c3e50;
}

.desktop-menu {
  display: flex;
  gap: 30px;
}

.desktop-menu li a, .mobile-menu li a {
  color: #333;
  text-decoration: none;
  transition: color 0.3s;
}

.desktop-menu li a:hover {
  color: #3498db;
}

.mobile-menu-btn {
  background: none;
  border: none;
  font-size: 1.5rem;
  cursor: pointer;
}

.mobile-menu {
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  background: #fff;
  padding: 20px;
  box-shadow: 0 2px 10px rgba(0,0,0,0.1);
  display: flex;
  flex-direction: column;
  gap: 15px;
}
</style>



// WEBPACK FOOTER //
// src/views/lcc/product.vue